import React from "react";
import { HoverCard, joinClasses } from "./ResultsPrimitives.jsx";

function FleetTruckStatusIconHoverCardContent({ description = "", title = "" }) {
  return (
    <div className="grid min-w-56 max-w-[18rem] gap-1.5">
      <p className="m-0 text-[0.7rem] font-semibold leading-5 text-content-ink">
        {title}
      </p>
      {description ? (
        <p className="m-0 whitespace-pre-line text-[0.68rem] leading-5 text-content-muted">
          {description}
        </p>
      ) : null}
    </div>
  );
}

export default function FleetTruckStatusIconHoverCard({
  accentColor,
  children,
  className = "",
  description = "",
  disabled = false,
  title = "",
}) {
  if (!title) {
    return children;
  }

  return (
    <HoverCard
      title=""
      content={<FleetTruckStatusIconHoverCardContent description={description} title={title} />}
      accentColor={accentColor}
      disabled={disabled}
      maxWidth={300}
      placement="top-start"
      referenceAsChild
    >
      <span
        className={joinClasses(["inline-flex", className])}
        onClick={(event) => event.stopPropagation()}
        onMouseEnter={(event) => event.stopPropagation()}
        onPointerDown={(event) => event.stopPropagation()}
      >
        {children}
      </span>
    </HoverCard>
  );
}
